import logoUrl from '@/assets/logo.png';
import whiteLogoUrl from '@/assets/logo_white.png';
import { Typography } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import { useStytchB2BClient } from '@stytch/react/b2b';
import { useState, type ReactElement } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLocalizedStrings } from '../../localization/LocalizedStringsProvider';
import Spacer from '../common/Spacer';
import { useColorScheme } from "@mui/material/styles";

const ChooseOrganization = (): ReactElement => {
    const [orgSlug, setOrgSlug] = useState("");    
    const [errorMessage, setErrorMessage] = useState("");
    const stytch = useStytchB2BClient();
    const navigate = useNavigate();    
    const strings = useLocalizedStrings();    
    const { mode } = useColorScheme();

    const handleSignInClick = async () => {
        const response = await stytch.organization.getBySlug({ organization_slug: orgSlug });
        if (!response || !response.organization) {
            setErrorMessage(strings.orgNotFound.replace("{{slug}}", orgSlug));
            return;
        }

        navigate(orgSlug);
    };

    return (
        <Box
            component="form"
            sx={{
                '& > :not(style)': { m: 1, width: '40ch' },
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '100dvh', // full viewport (use 100vh if you prefer) 
            }}
            noValidate
            autoComplete="off"
        >
            <Stack direction="column">
                <img src={mode === 'dark' ? whiteLogoUrl : logoUrl} alt="TouchTabLogo" />
                <Spacer y={4} />
                <TextField
                    id="org-slug"
                    label={strings.organizationId}
                    variant="outlined"
                    value={orgSlug}
                    onChange={(e) => setOrgSlug(e.target.value)} 
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            e.stopPropagation();
                            e.preventDefault();
                            handleSignInClick();                           
                        }
                    }}
                />
                <Spacer y={1} />                
                <Button variant="contained" onClick={handleSignInClick}>{strings.goToLogin}</Button>        
                <Spacer y={2} />
                <Typography sx={{ alignSelf: 'center' }} color="error">{errorMessage}</Typography>
            </Stack>
        </Box>
    )
}

export default ChooseOrganization;